import { BLOTTER_PANELS } from '@src/components/AppLayout/Layouts/Trading/shared';
import { forEachTradingLayoutSpecForTabsMigration } from './blotterTabsMigrationHelpers';
import type { AppConfigStateWithLegacyLayoutConfigs } from './legacyLayoutConfigs.types';

const BLOTTER_COMPONENTS_WITH_DEFAULT_TAB = new Set(
  Object.values(BLOTTER_PANELS)
    .filter(panel => panel.tabComponent !== 'readOnly')
    .map(panel => panel.contentComponent)
);

/**
 * Older saved layouts may still include `tabComponent: 'readOnly'` from before these
 * blotters switched back to the default tab renderer. Strip that stale value only for
 * blotter types that are now addable and no longer explicitly read-only.
 */
export function removeLegacyReadOnlyTabComponentsFromBlotterPanels(initialConfig: unknown) {
  const config = initialConfig as AppConfigStateWithLegacyLayoutConfigs;

  forEachTradingLayoutSpecForTabsMigration(config, layoutConfig => {
    const panels = layoutConfig?.dockViewLayout?.panels;
    if (panels == null) {
      return;
    }

    for (const panel of Object.values(panels)) {
      if (panel == null) {
        continue;
      }
      const panelType = panel.contentComponent ?? panel.params?.type;

      if (
        panel.tabComponent !== 'readOnly' ||
        typeof panelType !== 'string' ||
        !BLOTTER_COMPONENTS_WITH_DEFAULT_TAB.has(panelType as any)
      ) {
        continue;
      }

      panel.tabComponent = undefined;
    }
  });
}
